<p-menu #rowMenu [model]="rowMenuItems" [popup]="true" appendTo="body" />

<div class="space-y-4 sm:space-y-6">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <div>
      <!-- <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'ORDERS.TITLE' | translate }}
      </h1> -->
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
        {{ 'ORDERS.TOTAL_COUNT' | translate: { count: totalCount() } }}
      </p>
    </div>
  </div>

  <!-- Profit Report Cards -->
  @if (reportLoading()) {
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-3">
      @for (_ of [1, 2, 3, 4]; track $index) {
        <div
          class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-3 sm:p-5 animate-pulse"
        >
          <div class="h-2.5 w-20 bg-gray-200 dark:bg-gray-700 rounded mb-3"></div>
          <div class="h-6 w-28 bg-gray-200 dark:bg-gray-700 rounded"></div>
        </div>
      }
    </div>
  } @else if (report()) {
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <!-- Revenue -->
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-3 sm:p-5"
      >
        <p
          class="text-[10px] sm:text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider leading-tight"
        >
          {{ 'ORDERS.REPORT.REVENUE' | translate }}
        </p>
        <p
          class="text-lg sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1 leading-tight tabular-nums"
        >
          {{ report()!.totalRevenue | money: report()!.currency }}
        </p>
      </div>
      <!-- Profit -->
      <div
        class="rounded-xl border border-emerald-200 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-900/20 p-3 sm:p-5"
      >
        <p
          class="text-[10px] sm:text-xs font-medium text-emerald-600 dark:text-emerald-400 uppercase tracking-wider leading-tight"
        >
          {{ 'ORDERS.REPORT.PROFIT' | translate }}
        </p>
        <p
          class="text-lg sm:text-2xl font-bold text-emerald-700 dark:text-emerald-300 mt-1 leading-tight tabular-nums"
        >
          {{ report()!.grossProfit | money: report()!.currency }}
        </p>
      </div>
      <!-- Cost -->
      <div
        class="rounded-xl border border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-900/20 p-3 sm:p-5"
      >
        <p
          class="text-[10px] sm:text-xs font-medium text-green-600 dark:text-green-400 uppercase tracking-wider leading-tight"
        >
          {{ 'ORDERS.REPORT.COST' | translate }}
        </p>
        <p
          class="text-lg sm:text-2xl font-bold text-green-700 dark:text-green-300 mt-1 leading-tight tabular-nums"
        >
          {{ report()!.totalCost | money: report()!.currency }}
        </p>
      </div>
      <!-- Discount -->
      <div
        class="rounded-xl border border-orange-200 dark:border-orange-800 bg-orange-50 dark:bg-orange-900/20 p-3 sm:p-5"
      >
        <p
          class="text-[10px] sm:text-xs font-medium text-orange-600 dark:text-orange-400 uppercase tracking-wider leading-tight"
        >
          {{ 'ORDERS.REPORT.DISCOUNT' | translate }}
        </p>
        <p
          class="text-lg sm:text-2xl font-bold text-orange-700 dark:text-orange-300 mt-1 leading-tight tabular-nums"
        >
          {{ report()!.totalDiscount | money: report()!.currency }}
        </p>
      </div>
    </div>
  }

  <!-- Filters -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-3 sm:p-4"
  >
    <div class="flex flex-col gap-2.5">
      <!-- Search — full width -->
      <input
        pInputText
        [placeholder]="'ORDERS.FILTER.SEARCH' | translate"
        class="w-full"
        [(ngModel)]="searchQuery"
        (keyup.enter)="onSearch()"
      />

      <!-- Selects + date pickers — 2 cols on mobile, 4 on lg -->
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-2.5">
        <!-- Bitta do'konda filtr yashiriladi: "hammasi" bilan bir xil natija beradi. -->
        @if (storePick.visible()) {
          <p-multiselect
            [options]="stores()"
            optionLabel="name"
            optionValue="id"
            [placeholder]="'ORDERS.FILTER.STORE' | translate"
            [showClear]="true"
            [(ngModel)]="filterStoreIds"
            (onChange)="onSearch()"
            display="chip"
            appendTo="body"
            class="w-full"
          />
        }
        <p-select
          [options]="paymentTypes"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'ORDERS.FILTER.PAYMENT_TYPE' | translate"
          [showClear]="true"
          [(ngModel)]="filterPaymentType"
          (onChange)="onSearch()"
          class="w-full"
        />
        <p-datepicker
          [(ngModel)]="filterFrom"
          [placeholder]="'ORDERS.FILTER.FROM' | translate"
          dateFormat="dd.mm.yy"
          [showClear]="true"
          (onClearClick)="onSearch()"
          (onSelect)="onSearch()"
          class="w-full"
        />
        <p-datepicker
          [(ngModel)]="filterTo"
          [placeholder]="'ORDERS.FILTER.TO' | translate"
          dateFormat="dd.mm.yy"
          [showClear]="true"
          (onClearClick)="onSearch()"
          (onSelect)="onSearch()"
          class="w-full"
        />
        <!--
          Foyda hisoboti FAQAT bitta valyuta daftaridan o'qiladi (I11) — tanlagich
          bir nechta valyuta yoqilgan bo'lsagina chiqadi.
        -->
        @if (currencySvc.hasMultipleCurrencies()) {
          <p-select
            [options]="currencySvc.currencyOptions()"
            optionLabel="label"
            optionValue="value"
            [ngModel]="reportCurrency()"
            (ngModelChange)="onReportCurrencyChange($event)"
            [ariaLabel]="'ORDERS.FILTER.CURRENCY' | translate"
            appendTo="body"
            class="w-full"
          />
        }
      </div>

      <!-- Search button -->
      <div class="flex justify-end">
        <p-button
          icon="pi pi-search"
          [label]="'ORDERS.FILTER.SEARCH_BTN' | translate"
          severity="secondary"
          (onClick)="onSearch()"
          class="w-full sm:w-auto"
          styleClass="w-full sm:w-auto"
        />
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
    <p-table
      [value]="orders()"
      [lazy]="true"
      (onLazyLoad)="loadOrders($event)"
      [totalRecords]="totalCount()"
      [paginator]="true"
      [rows]="pageSize"
      [rowsPerPageOptions]="[20, 50, 100]"
      [loading]="loading()"
      [showCurrentPageReport]="false"
      [showFirstLastIcon]="false"
      styleClass="p-datatable-gridlines"
      [tableStyle]="{ 'min-width': '62rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">#</th>
          <th>{{ 'ORDERS.TABLE.RECEIPT' | translate }}</th>
          <th pSortableColumn="orderDate">
            {{ 'ORDERS.TABLE.DATE' | translate }} <p-sortIcon field="orderDate" />
          </th>
          <th>{{ 'ORDERS.TABLE.STORE' | translate }}</th>
          <th>{{ 'ORDERS.TABLE.CASHIER' | translate }}</th>
          <th pSortableColumn="totalAmount">
            {{ 'ORDERS.TABLE.AMOUNT' | translate }} <p-sortIcon field="totalAmount" />
          </th>
          <th>{{ 'ORDERS.TABLE.DISCOUNT' | translate }}</th>
          <th>{{ 'ORDERS.TABLE.PAID' | translate }}</th>
          <th>{{ 'ORDERS.TABLE.PAYMENT_TYPE' | translate }}</th>
          <th>{{ 'ORDERS.TABLE.STATUS' | translate }}</th>
          <th>{{ 'ORDERS.TABLE.DEBTOR' | translate }}</th>
          <th style="width: 3.5rem"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-order let-rowIndex="rowIndex">
        <tr>
          <td class="text-gray-500 dark:text-gray-400 text-sm">{{ rowIndex + 1 }}</td>
          <td>
            <code class="text-xs bg-gray-100 dark:bg-gray-800 px-2 py-0.5 rounded font-mono">
              {{ order.receiptNumber || '—' }}
            </code>
          </td>
          <td class="text-gray-700 dark:text-gray-300 text-sm whitespace-nowrap">
            {{ order.orderDate | date: 'dd.MM.yyyy HH:mm' }}
          </td>
          <td class="text-gray-700 dark:text-gray-300 text-sm">{{ order.storeName }}</td>
          <td class="text-gray-700 dark:text-gray-300 text-sm">{{ order.cashierName }}</td>
          <td class="whitespace-nowrap tabular-nums">
            <div class="font-semibold text-gray-900 dark:text-gray-100">
              {{ order.totalAmount | money: order.currency }}
            </div>
            @if (order.totalDiscount > 0) {
              <div class="text-xs text-gray-400 line-through">
                {{ order.totalAmount + order.totalDiscount | money: order.currency }}
              </div>
            }
          </td>
          <td class="whitespace-nowrap tabular-nums">
            @if (order.totalDiscount > 0) {
              <span class="text-orange-600 dark:text-orange-400 font-medium">
                −{{ order.totalDiscount | money: order.currency }}
              </span>
            } @else {
              <span class="text-gray-400">—</span>
            }
          </td>
          <td class="text-gray-700 dark:text-gray-300 whitespace-nowrap tabular-nums">
            {{ order.paidAmount | money: order.currency }}
          </td>
          <td>
            <p-tag
              [value]="getPaymentLabel(order.paymentType)"
              [severity]="getPaymentSeverity(order.paymentType)"
            />
          </td>
          <td>
            <p-tag
              [value]="getStatusLabel(order.status)"
              [severity]="getStatusSeverity(order.status)"
            />
          </td>
          <td class="text-sm">
            @if (order.debtCustomerName) {
              <div class="text-red-600 dark:text-red-400 font-medium">
                {{ order.debtCustomerName }}
              </div>
              @if (order.debtCustomerPhone) {
                <div class="text-gray-400 text-xs">{{ order.debtCustomerPhone }}</div>
              }
            } @else {
              <span class="text-gray-400">—</span>
            }
          </td>
          <td>
            <p-button
              icon="pi pi-ellipsis-v"
              [text]="true"
              severity="secondary"
              size="small"
              (onClick)="openRowMenu($event, rowMenu, order)"
            />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="12" class="text-center py-12 text-gray-500 dark:text-gray-400">
            <div class="flex flex-col items-center gap-2">
              <i class="pi pi-shopping-cart text-4xl text-gray-300"></i>
              <span>{{ 'ORDERS.EMPTY' | translate }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Order Details Dialog -->
<p-dialog
  [header]="'ORDERS.DETAIL.TITLE' | translate"
  [(visible)]="detailsVisible"
  [modal]="true"
  [style]="{ width: 'min(52rem, 95vw)' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDetails()"
>
  @if (detailsLoading) {
    <div class="flex items-center justify-center py-12 text-gray-400">
      <i class="pi pi-spin pi-spinner text-2xl mr-2"></i>
      {{ 'ORDERS.DETAIL.LOADING' | translate }}
    </div>
  } @else if (selectedOrder()) {
    <div class="flex flex-col gap-5 pt-2">
      <!-- Meta info -->
      <div class="grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm">
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'ORDERS.DETAIL.RECEIPT' | translate }}
          </p>
          <code class="bg-gray-100 dark:bg-gray-800 px-2 py-0.5 rounded text-xs font-mono">
            {{ selectedOrder()!.receiptNumber || '' }}
          </code>
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'ORDERS.DETAIL.DATE' | translate }}
          </p>
          <p class="text-gray-900 dark:text-gray-100 font-medium">
            {{ selectedOrder()!.orderDate | date: 'dd.MM.yyyy HH:mm' }}
          </p>
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'ORDERS.DETAIL.STORE' | translate }}
          </p>
          <p class="text-gray-900 dark:text-gray-100 font-medium">
            {{ selectedOrder()!.storeName }}
          </p>
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'ORDERS.DETAIL.CASHIER' | translate }}
          </p>
          <p class="text-gray-900 dark:text-gray-100 font-medium">
            {{ selectedOrder()!.cashierName }}
          </p>
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'ORDERS.DETAIL.PAYMENT_TYPE' | translate }}
          </p>
          <p-tag
            [value]="getPaymentLabel(selectedOrder()!.paymentType)"
            [severity]="getPaymentSeverity(selectedOrder()!.paymentType)"
          />
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'ORDERS.DETAIL.STATUS' | translate }}
          </p>
          <p-tag
            [value]="getStatusLabel(selectedOrder()!.status)"
            [severity]="getStatusSeverity(selectedOrder()!.status)"
          />
        </div>
        @if (selectedOrder()!.debtCustomerName) {
          <div class="col-span-2">
            <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
              {{ 'ORDERS.DETAIL.DEBTOR' | translate }}
            </p>
            <p class="text-red-600 dark:text-red-400 font-medium">
              {{ selectedOrder()!.debtCustomerName }}
              @if (selectedOrder()!.debtCustomerPhone) {
                · {{ selectedOrder()!.debtCustomerPhone }}
              }
            </p>
          </div>
        }
      </div>

      <!-- Items table -->
      <div class="rounded-lg border border-gray-200 dark:border-gray-700 overflow-x-auto">
        <table class="w-full text-sm min-w-[32rem]">
          <thead class="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th
                class="text-left px-4 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.DETAIL.PRODUCT' | translate }}
              </th>
              <th
                class="text-right px-4 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.DETAIL.QTY' | translate }}
              </th>
              <th
                class="text-right px-4 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.DETAIL.PRICE' | translate }}
              </th>
              <th
                class="text-right px-4 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.DETAIL.DISCOUNT' | translate }}
              </th>
              <th
                class="text-right px-4 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.DETAIL.SUBTOTAL' | translate }}
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (item of selectedOrder()!.items; track item.productId) {
              <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/40">
                <td class="px-4 py-2.5 text-gray-900 dark:text-gray-100 font-medium">
                  <span>{{ item.productName }}</span>
                  @if (item.variantLabel) {
                    <span class="block text-xs text-indigo-500 dark:text-indigo-400">{{
                      item.variantLabel
                    }}</span>
                  }
                </td>
                <td class="px-4 py-2.5 text-right text-gray-700 dark:text-gray-300">
                  @if (item.returnedQuantity > 0) {
                    <span class="tabular-nums">{{ itemRemainingQty(item) }}</span>
                    <span class="block text-xs text-red-500 dark:text-red-400 tabular-nums">
                      −{{ item.returnedQuantity }}
                    </span>
                  } @else {
                    {{ item.quantity }}
                  }
                </td>
                <td
                  class="px-4 py-2.5 text-right text-gray-700 dark:text-gray-300 whitespace-nowrap tabular-nums"
                >
                  {{ item.unitPrice | money: selectedOrder()!.currency }}
                </td>
                <td class="px-4 py-2.5 text-right">
                  @if (item.discount > 0) {
                    <span class="text-orange-600 dark:text-orange-400 tabular-nums">{{
                      item.discount | money: selectedOrder()!.currency
                    }}</span>
                  } @else {
                    <span class="text-gray-400">—</span>
                  }
                </td>
                <td
                  class="px-4 py-2.5 text-right font-semibold text-gray-900 dark:text-gray-100 whitespace-nowrap tabular-nums"
                >
                  @if (item.returnedQuantity > 0 && itemRemainingQty(item) === 0) {
                    <span class="text-gray-400 line-through">{{
                      item.subTotal | money: selectedOrder()!.currency
                    }}</span>
                  } @else {
                    {{ itemNetSubTotal(item) | money: selectedOrder()!.currency }}
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Totals -->
      <div
        class="flex flex-col items-end gap-1.5 text-sm border-t border-gray-100 dark:border-gray-800 pt-4"
      >
        @if (detailTotalDiscount() > 0) {
          <div class="flex gap-12 sm:gap-16">
            <span class="text-gray-500 dark:text-gray-400">{{
              'ORDERS.DETAIL.ORIGINAL' | translate
            }}</span>
            <span class="text-gray-500 dark:text-gray-400 line-through tabular-nums">
              {{ detailOriginalTotal() | money: selectedOrder()!.currency }}
            </span>
          </div>
          <div class="flex gap-12 sm:gap-16">
            <span class="text-gray-500 dark:text-gray-400">{{
              'ORDERS.DETAIL.DISCOUNT' | translate
            }}</span>
            <span class="font-semibold text-orange-600 dark:text-orange-400 tabular-nums">
              −{{ detailTotalDiscount() | money: selectedOrder()!.currency }}
            </span>
          </div>
        }
        <div class="flex gap-12 sm:gap-16">
          <span class="text-gray-500 dark:text-gray-400">{{
            'ORDERS.DETAIL.TOTAL' | translate
          }}</span>
          <span class="font-bold text-gray-900 dark:text-gray-100 tabular-nums">
            {{ selectedOrder()!.totalAmount | money: selectedOrder()!.currency }}
          </span>
        </div>
        <div class="flex gap-12 sm:gap-16">
          <span class="text-gray-500 dark:text-gray-400">{{
            'ORDERS.DETAIL.PAID_AMOUNT' | translate
          }}</span>
          <span class="font-semibold text-emerald-600 dark:text-emerald-400 tabular-nums">
            {{ selectedOrder()!.paidAmount | money: selectedOrder()!.currency }}
          </span>
        </div>
        @if (selectedOrder()!.totalAmount > selectedOrder()!.paidAmount) {
          <div class="flex gap-12 sm:gap-16">
            <span class="text-gray-500 dark:text-gray-400">{{
              'ORDERS.DETAIL.DEBT' | translate
            }}</span>
            <span class="font-semibold text-red-600 dark:text-red-400 tabular-nums">
              {{
                selectedOrder()!.totalAmount - selectedOrder()!.paidAmount
                  | money: selectedOrder()!.currency
              }}
            </span>
          </div>
        }
      </div>
    </div>
  }

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'ORDERS.REPRINT' | translate"
        icon="pi pi-print"
        [disabled]="!selectedOrder()"
        (onClick)="openReceipt(selectedOrder()!.id)"
      />
      <p-button
        [label]="'ORDERS.CLOSE' | translate"
        severity="secondary"
        [outlined]="true"
        (onClick)="closeDetails()"
      />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [visible]="receiptVisible()"
  (visibleChange)="receiptVisible.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  styleClass="w-full max-w-sm receipt-print-dialog"
  [header]="'ORDERS.RECEIPT_TITLE' | translate"
>
  @if (receipt(); as currentReceipt) {
    <app-receipt [receipt]="currentReceipt" />
  }

  <ng-template pTemplate="footer">
    <!-- "Yopish" oxirida, "Chop etish" yonida — sotuv oynasidagi tartib bilan bir xil. -->
    <div class="flex flex-wrap gap-2 justify-end">
      <p-button
        [label]="'SALES.RECEIPT.PDF' | translate"
        icon="pi pi-file-pdf"
        severity="secondary"
        [outlined]="true"
        [loading]="exportBusy()"
        (onClick)="downloadReceiptPdf()"
      />
      <p-button
        [label]="'SALES.RECEIPT.SHARE' | translate"
        icon="pi pi-share-alt"
        severity="secondary"
        [outlined]="true"
        [loading]="shareBusy()"
        (onClick)="shareReceipt()"
      />
      <p-button
        [label]="'SALES.RECEIPT.PRINT' | translate"
        icon="pi pi-print"
        (onClick)="printReceipt()"
      />
      <p-button
        [label]="'COMMON.CLOSE' | translate"
        severity="secondary"
        (onClick)="receiptVisible.set(false)"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Return Dialog -->
<app-return-dialog [(visible)]="returnVisible" [order]="returnOrder()" (returned)="onReturned()" />
